import React from 'react'

export default function FAQ() {
  return (
    <iframe title="Food Order Knowledge Base" src='https://foodorder.tawk.help' width="100%" height="500"></iframe>
  )
}
